import { postData, getData, putData, } from '../axiosServices'

export const getAllMakerPlans = () => {
    let url = 'makerplans'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const getAllMakerPlansByLab = (labId) => {
    let url = `makerplans/lab/${labId}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const getMakerPlanByLabType = (coeId,labType) => {
    const url = `makerplans/coe/${coeId}/labtype/${labType}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};
export const getAllMakerPlanDetails = (malerPlan_id) => {
    let url = `makerplans/${malerPlan_id}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const addMakerPlan = (data) => {
    const url = `makerplans`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return postData(url, data, { headers });
}
export const addMakerPlanModule = (makerplanId, makermoduleId, data) => {
    const url = `makerplanmodlues/${makerplanId}/makermodule/${makermoduleId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return postData(url, data, { headers });
}
export const updateMakerPlan = (malerPlan_id, data) => {
    const url = `makerplans/${malerPlan_id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, data, { headers })
}
export const updateMakerPlanModule = (makerplanmodule_id, makerPlan_id, makermodule_id, data) => {
    const url = `makerplanmodlues/${makerplanmodule_id}/makerplan/${makerPlan_id}/makermodule/${makermodule_id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, data, { headers })
}
export const disableMakerPlanModule = (makerplanmodule_id, makerPlan_id, makermodule_id) => {
    const url = `makerplanmodlues/${makerplanmodule_id}/makerplan/${makerPlan_id}/makermodule/${makermodule_id}/isdisable`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, {}, { headers })
}